export default __webpack_public_path__ + "static/company-shape-93854fc903e4bb2399a820e784428dba.png";